import { render, staticRenderFns } from "./PartnerRegisterPopup.vue?vue&type=template&id=5370f3a2&"
import script from "./PartnerRegisterPopup.vue?vue&type=script&lang=js&"
export * from "./PartnerRegisterPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports